import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import styles from './styles';
/**
 */
export default class AmityekoSpinner extends LitElement {
    render() {
        return html `<div
      class="spinner"
      style=${styleMap({
            '--private-spinner-width': this.width,
            '--private-spinner-height': this.height,
            '--private-spinner-div-width': this.width && parseInt(this.width) > 30 ? '4px' : '2px',
        })}
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>`;
    }
}
AmityekoSpinner.styles = styles;
__decorate([
    property()
], AmityekoSpinner.prototype, "width", void 0);
__decorate([
    property()
], AmityekoSpinner.prototype, "height", void 0);
if (!customElements.get('amityeko-spinner')) {
    customElements.define('amityeko-spinner', AmityekoSpinner);
}
//# sourceMappingURL=index.js.map